import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppStateService } from 'src/app/core/services';
import { ContentRequestStateName } from 'src/app/shared/api-models/admin';
import { UserRole } from 'src/app/shared/api-models/admin/user-role.enum';
import { SortConfig } from 'src/app/shared/view-models/sort-config';
import { ContentRequestsRouteState, ContentRequestTable } from '../_models';
import { ContentRequestType } from '../_models/content-request-type.enum';
import { ContentRequestsService, MergeRequestsService, TableViewStateService } from '../_services';

@Component({
	selector: 'cr-content-requests-table',
	templateUrl: './content-requests-table.component.html'
})
export class ContentRequestsTableComponent {
	@Input() getSortIconClass: (column: string) => string;
	@Input() sortConfig: SortConfig;
	@Output() handlePaginationClick: EventEmitter<number> = new EventEmitter();
	@Output() handleRowSelect: EventEmitter<ContentRequestTable> = new EventEmitter();
	@Output() handleSortClick: EventEmitter<SortConfig> = new EventEmitter();

	readonly contentRequestType = ContentRequestType;

	get holdAndUserIsAudioContentCreator() {
		const { currentUser } = this.appStateService;
		const { filterByRequestType } = this.viewStateService;
		return filterByRequestType === ContentRequestType.ON_HOLD_MESSAGE && currentUser.Role === UserRole.AUDIO_CONTENT_CREATOR;
	}

	get itemsPerPage() {
		if (this.holdAndUserIsAudioContentCreator) {
			return 500;
		}
		return 50;
	}

	get showPagination() {
		if (this.contentRequestsService.requests?.length > 0 && this.holdAndUserIsAudioContentCreator) {
			return false;
		}
		return true;
	}

	get isClientFacingRoute() {
		return this.viewStateService.route === ContentRequestsRouteState.CONTENT_REQUESTS;
	}

	get showIdColumn() {
		const { filterByRequestType } = this.viewStateService;
		return this.holdAndUserIsAudioContentCreator || filterByRequestType === ContentRequestType.ON_HOLD_MESSAGE;
	}

	get showVoiceTalentColumn() {
		const { filterByRequestType } = this.viewStateService;
		return this.holdAndUserIsAudioContentCreator || filterByRequestType === ContentRequestType.ON_HOLD_MESSAGE || this.isClientFacingRoute;
	}

	get selectedRequestTypeIsVideoOrAll() {
		const { filterByRequestType } = this.viewStateService;
		return filterByRequestType === ContentRequestType.VIDEO_LOBBY || filterByRequestType === ContentRequestType.ALL;
	}

	get showRequestTypeColumn() {
		const { filterByRequestType } = this.viewStateService;
		return filterByRequestType === ContentRequestType.ALL;
	}

	constructor(
		private appStateService: AppStateService,
		public contentRequestsService: ContentRequestsService,
		public mergeRequestsService: MergeRequestsService,
		public viewStateService: TableViewStateService
	) {}

	public rowBgColor(request: ContentRequestTable): string {
		const { route } = this.viewStateService;
		const { StateName, RequestType } = request;

		if (StateName === ContentRequestStateName.CANCELLED || StateName === ContentRequestStateName.MERGED) {
			return 'bg-gray-400';
		} else if (RequestType === ContentRequestType.ON_HOLD_MESSAGE && route !== ContentRequestsRouteState.CONTENT_REQUESTS) {
			return 'bg-blue-200';
		} else if (RequestType === ContentRequestType.ON_HOLD_MESSAGE && route === ContentRequestsRouteState.CONTENT_REQUESTS) {
			return 'bg-white';
		} else {
			return 'bg-red-200';
		}
	}
}
